<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      title="选择供应商"
      :visible.sync="Open"
      width="800px"
      :close-on-click-modal="false"
    >
      <BaseTable
        ref="baseTable"
        :fn-init="Fninit"
        :table="table"
        @handleSelect="handleSelect"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="dialogConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { supplierChoose } from '@/api/supplier'
  import { defaultSearchOptions } from './config'
  import { productCategoryTreeList } from '@/api/goods/productCategory.js'
  import { listUserOptions } from '@/api/setting/system/user'
  export default {
    components: {},
    props: {
      excludeSupplierIdList: {
        type: Array,
        default: () => {
          return []
        },
      },
      isSend: {
        type: Boolean,
        default: false,
      },

      rowInfo: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      let _this = this
      return {
        Open: true,
        form: {},
        tableData: [],
        suppliervisible: true, // 供应商显示隐藏
        rules: {},
        table: {
          name: '',
          defaultParams: {},
          showSearchBar: true,
          selection: false,
          searchOptions: JSON.parse(JSON.stringify(defaultSearchOptions)),
          canRefresh: false, // 刷新按钮
          showMoreBtns: false, // 展示新增按钮
          moreBtns: [],
          // 草稿 tempStorage  1 2
          options: [
            {
              label: '供应商编码',
              key: 'supplierCode',
              type: 'name',
              align: 'center',
              visible: true,
            },
            {
              label: '供应商名称',
              key: 'supplierName',
              type: 'name',
              visible: true,
              copy: false,
              width: '160',
              overflow: 10,
            },
            {
              label: '供应商简称',
              key: 'shortName',
              align: 'center',
              type: 'name',
              copy: false,
              visible: true,
            },
            {
              label: '擅长类目',
              key: 'categoryFullNames',
              type: 'name',
              align: 'center',
              visible: true,
            },
            {
              label: '对接采购',
              key: 'contactUserNames',
              type: 'name',
              align: 'center',
              visible: true,
            },
          ],
        },

        Fninit: () => {
          return {
            initData(params) {
              return new Promise((resolve) => {
                console.log(
                  '🚀 ~ returnnewPromise ~ _this.isSend:',
                  _this.isSend
                )

                if (_this.isSend) {
                  this.table.defaultParams.isSend = 1
                }
                params.excludeSupplierIdList = _this.excludeSupplierIdList
                supplierChoose(
                  this.objectSavekey(params),
                  this.objectDelkey(params)
                ).then((res) => {
                  resolve(res)
                })
              })
            },
            clearOptions() {
              // 重置清空搜索框
              this.table.defaultParams = {
                isSend: _this.isSend ? 1 : undefined,
              }
              this.table.searchOptions = JSON.parse(
                JSON.stringify(defaultSearchOptions)
              )
              // this._initData();
            },
          }
        },
      }
    },
    created() {
      this.getproductCategoryTreeList()
      this.getlistUserOptions()
    },

    methods: {
      getlistUserOptions() {
        listUserOptions({ userStatus: 1 }).then((res) => {
          res.data.forEach((item) => {
            item.label = item.userName
            item.id = item.userId
          })
          defaultSearchOptions[1].options = res.data
          this.table.searchOptions[1].options = res.data
        })
      },
      getproductCategoryTreeList() {
        productCategoryTreeList({
          categoryStatus: 1,
          levelList: [1, 2, 3],
        }).then((res) => {
          defaultSearchOptions[0].options = res.data
          this.table.searchOptions[0].options = res.data
        })
      },
      handleClose() {
        this.$emit('getSupplierList')
      },
      handleSelect(val) {
        this.$emit('getSupplierList', val)
      },
      dialogConfirm() {
        this.$emit('getSupplierList', this.$refs.baseTable.clickRow)
      },
    },
  }
</script>
<style lang="scss" scoped></style>
